const libraries = document.querySelectorAll('[data-documents]');

libraries.forEach((library) => {
    const form = library.querySelector('[data-document-filters]');
    const results = library.querySelector('[data-document-results]');
    const clear = library.querySelector('[data-clear-document-filters]');
    const search = library.querySelector('[data-document-search]');
    const endpoint = library.dataset.resultsEndpoint;

    if (!form || !results || !clear || !search || !endpoint) {
        return;
    }

    form.classList.add('is-enhanced');

    let activeRequest = null;
    let searchTimer = null;

    const normalisePaginationLinks = () => {
        results.querySelectorAll('[data-document-pagination] a').forEach((link) => {
            const url = new URL(link.href, window.location.href);
            link.href = `${form.action}${url.search}`;
        });
    };

    const parametersFromForm = () => {
        const parameters = new URLSearchParams(new FormData(form));
        parameters.set('search', search.value.trim());

        [...parameters.entries()].forEach(([name, value]) => {
            if (!value) {
                parameters.delete(name);
            }
        });

        return parameters;
    };

    const loadResults = async (parameters, updateHistory = true) => {
        if (activeRequest) {
            activeRequest.abort();
        }

        activeRequest = new AbortController();
        const query = parameters.toString();
        const pageUrl = `${form.action}${query ? `?${query}` : ''}`;
        const resultsUrl = `${endpoint}${query ? `?${query}` : ''}`;

        if (updateHistory) {
            window.history.pushState({}, '', pageUrl);
        }

        results.setAttribute('aria-busy', 'true');

        try {
            const response = await fetch(resultsUrl, {
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                signal: activeRequest.signal,
            });

            if (!response.ok) {
                throw new Error(`Document request failed with status ${response.status}`);
            }

            results.innerHTML = await response.text();
            normalisePaginationLinks();
        } catch (error) {
            if (error.name !== 'AbortError') {
                window.location.assign(pageUrl);
            }
        } finally {
            results.removeAttribute('aria-busy');
        }
    };

    const syncFormFromUrl = () => {
        const parameters = new URLSearchParams(window.location.search);
        search.value = parameters.get('search') || '';
        const topic = parameters.get('topic') || '';
        const type = parameters.get('type') || '';
        const activities = new Set(parameters.getAll('activity[]'));

        form.querySelectorAll('[name="topic"]').forEach((input) => {
            input.checked = input.value === topic;
        });
        form.querySelectorAll('[name="type"]').forEach((input) => {
            input.checked = input.value === type;
        });
        form.querySelectorAll('[name="activity[]"]').forEach((input) => {
            input.checked = activities.has(input.value);
        });
    };

    form.addEventListener('submit', (event) => {
        event.preventDefault();
        window.clearTimeout(searchTimer);
        loadResults(parametersFromForm());
    });

    form.addEventListener('change', (event) => {
        if (event.target === search) {
            return;
        }

        loadResults(parametersFromForm());
    });

    search.addEventListener('input', () => {
        window.clearTimeout(searchTimer);
        searchTimer = window.setTimeout(() => {
            loadResults(parametersFromForm());
        }, 300);
    });

    results.addEventListener('click', (event) => {
        const link = event.target.closest('[data-document-pagination] a');

        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return;
        }

        event.preventDefault();
        const parameters = new URL(link.href, window.location.href).searchParams;
        loadResults(parameters).then(() => {
            results.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    });

    clear.addEventListener('click', (event) => {
        event.preventDefault();
        window.clearTimeout(searchTimer);
        search.value = '';
        form.querySelector('[name="topic"][value=""]').checked = true;
        form.querySelector('[name="type"][value=""]').checked = true;
        form.querySelectorAll('[name="activity[]"]').forEach((input) => {
            input.checked = false;
        });
        loadResults(new URLSearchParams());
    });

    window.addEventListener('popstate', () => {
        window.clearTimeout(searchTimer);
        syncFormFromUrl();
        loadResults(new URLSearchParams(window.location.search), false);
    });

    normalisePaginationLinks();
});
